<h2>{{'settings.title' | translate}}
  <button type="button" style="float:right;" (click)="closeSettings()">X</button>

</h2>
<p>
  <button type="button">
    <a href="https://docs.google.com/forms/d/e/1FAIpQLSeDVXEd8VMzvTVAgy32LLo0J5GR4El32E3quovcYViz6ticaQ/viewform"
      target="_blank">
      {{'settings.feedback' | translate}}
    </a>
  </button>
</p>

<form [formGroup]="paramsForm" (ngSubmit)="onSubmit(paramsForm.value)" style="margin-top: 2em;">
  <table class="bottom-border">
    <tr>
      <td>{{'settings.toggle_fs' | translate}}</td>
      <td>
        <button (click)="toggleFullScreen()" id="toggle_fs" title="Toggle on/off full screen.">
          {{'settings.toggle' | translate}}
        </button>
    </tr>
    <tr>
      <td>{{'settings.event_list_location' | translate}}</td>
      <td>
        <select formControlName="tablePosition">
          <option *ngFor="let loc of tableLocations" [value]="loc.class">{{loc.name}}</option>
        </select>
    </tr>
    <tr>
      <td>{{'settings.event_list_location_loop' | translate}}</td>
      <td><input type="checkbox" formControlName="cycleTablePosition"></td>
    </tr>
    <tr>
      <td>{{'settings.color_pallet' | translate}}
        <br>
        <small><i>{{'settings.requires_reload' | translate}}</i></small>
      </td>
      <td>
        <select formControlName="colorPalletIndex">
          <option *ngFor="let pal of colorPallet; index as i" [value]="i">{{pal.name}}</option>
        </select>
    </tr>
    <tr>
      <td>{{'settings.date_type' | translate}}
      </td>
      <td>
        <select formControlName="dateType">
          <option *ngFor="let val of ['absolute', 'relative'];" [value]="val">{{val}}</option>
        </select>
    </tr>
    <tr>
      <td>{{'settings.base_map' | translate}}
        <br>
        <small><i>{{'settings.requires_reload' | translate}}</i></small>
      </td>
      <td>
        <select formControlName="baseMap">
          <option *ngFor="let eff of baseMaps;" [value]="eff">{{eff}}</option>
        </select>
    </tr>
    <tr>
      <td>{{'settings.base_map_effects' | translate}}
        <br>
        <small><i>{{'settings.requires_reload' | translate}}</i></small>
      </td>
      <td>
        <select formControlName="baseMapEffect">
          <option *ngFor="let eff of baseMapEffects;" [value]="eff">{{eff}}</option>
        </select>
    </tr>
    <tr>
      <td>{{'settings.language' | translate}}
        <br>
        <small><i>{{'settings.requires_reload' | translate}}</i></small>
      </td>
      <td>
        <select formControlName="language">
          <option *ngFor="let lan of languages;" [value]="lan">{{lan}}</option>
        </select>
    </tr>
    <tr>
      <td>{{'settings.source' | translate}}
        <br>
        <small><i>{{'settings.requires_reload' | translate}}</i></small>
      </td>
      <td>
        <select formControlName="source">
          <option *ngFor="let source of sources;" [value]="source">{{source}}</option>
        </select>
    </tr>
    <tr>
      <td>{{'settings.catalog_update_interval' | translate}}</td>
      <td><input type="number" formControlName="dataFetchInterval" min="180"></td>
    </tr>
    <tr>
      <td>{{'settings.animate_how_many' | translate}}</td>
      <td><input type="number" formControlName="animateHowMany" min="1" max="20"></td>
    </tr>
    <tr>
      <td>{{'settings.smart_skip_region' | translate}}</td>
      <td><input type="checkbox" formControlName="smartRegion"></td>
    </tr>
  </table>
  <div style="margin: 1em 0;">
    {{'settings.keyboard_shortcuts' | translate}}
    <ul>
      <li><b>&rarr;</b> {{'settings.next_region' | translate}}</li>
      <li><b>&larr;</b> {{'settings.prev_region' | translate}}</li>
      <li><b>m</b> {{'settings.hs_options' | translate}}</li>
      <li><b>h</b> {{'settings.hs_ui' | translate}}</li>
    </ul>
  </div>


  <table formGroupName="regions" style="margin-top: 2em; margin-bottom: 2em;">
    <tr>
      <th title="Do not show this region.">{{'settings.hide' | translate}}</th>
      <th>{{'settings.region' | translate}}</th>
      <th title="Minimum magnitude to show in this region.">{{'settings.min_mag' | translate}}</th>
      <th title="Slide duration in seconds">{{'settings.duration' | translate}}</th>
    </tr>
    <tr>
      <td><input type="checkbox" (change)="checkAll($event, 'hideRegion')"></td>
      <td><i>{{'settings.apply_all' | translate}}</i></td>
      <td>
        <input type="number" (change)="checkAll($event, 'minMagnitudeToShow')" min="3" max="8">
      </td>
      <td>
        <input type="number" (change)="checkAll($event, 'slideDuration')" min="10">
      </td>
    </tr>
    <tr *ngFor="let region of ss.settings.regions; index as i" formGroupName="{{'region-' + i}}">
      <td>
        <input type="checkbox" formControlName="hideRegion">
      </td>
      <td>{{region.name}}</td>
      <td>
        <input type="number" formControlName="minMagnitudeToShow" min="3" max="8">
      </td>
      <td>
        <input type="number" formControlName="slideDuration" min="10">
      </td>
    </tr>
  </table>
  <button type="submit" [disabled]="!paramsForm.valid">{{'settings.save_settings' | translate}}</button>
  <button type="button" (click)="closeSettings()">{{'settings.close_settings' | translate}}</button>
</form>
<h3>{{'settings.about' | translate}}</h3>
<p>{{'settings.about_body' | translate}}</p>
<h3>{{'settings.about_iris' | translate}}</h3>
<p>{{'settings.about_iris_body' | translate}}</p>
<p>{{'settings.help_translate' | translate}}<a href="assets/i18n/en.json" target="_blank">en.json</a>
</p>
<p>
  <a [attr.href]="cacheBuster"><small>build: {{appVersion}}</small></a>
</p>
